import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getRequestLanguage } from './language';

// 导入新的 JSON 翻译文件
import enBase from './locales/en/base.json';
import enActivity from './locales/en/activity.json';
import enEducation from './locales/en/education.json';
import enOpenAccount from './locales/en/open_account.json';
import enSubscribtion from './locales/en/subscribtion.json';
import enGoldTopic from './locales/en/goldTopic.json';
import enGoldTrade from './locales/en/goldTrade.json';
import enStockIndices from './locales/en/stockIndices.json';
import enCrudeOil from './locales/en/crudeOil.json';
import enStrategyTrading from './locales/en/strategyTrading.json';
import enInvite from './locales/en/invite.json';
import enPrediction from './locales/en/prediction.json';
import enDepositCouponRewards from './locales/en/depositCouponRewards.json';
import enTradingTaskRewards from './locales/en/tradingTaskRewards.json';
import enTradingTaskIntro from './locales/en/tradingTaskIntro.json';
import enReward from './locales/en/reward.json';
import enSymbols from './locales/en/symbols.json';

import viBase from './locales/vi/base.json';
import viActivity from './locales/vi/activity.json';
import viEducation from './locales/vi/education.json';
import viOpenAccount from './locales/vi/open_account.json';
import viSubscribtion from './locales/vi/subscribtion.json';
import viGoldTopic from './locales/vi/goldTopic.json';
import viGoldTrade from './locales/vi/goldTrade.json';
import viStockIndices from './locales/vi/stockIndices.json';
import viCrudeOil from './locales/vi/crudeOil.json';
import viStrategyTrading from './locales/vi/strategyTrading.json';
import viInvite from './locales/vi/invite.json';
import viPrediction from './locales/vi/prediction.json';
import viDepositCouponRewards from './locales/vi/depositCouponRewards.json';
import viTradingTaskRewards from './locales/vi/tradingTaskRewards.json';
import viTradingTaskIntro from './locales/vi/tradingTaskIntro.json';
import viReward from './locales/vi/reward.json';
import viSymbols from './locales/vi/symbols.json';

import idBase from './locales/id/base.json';
import idActivity from './locales/id/activity.json';
import idEducation from './locales/id/education.json';
import idOpenAccount from './locales/id/open_account.json';
import idSubscribtion from './locales/id/subscribtion.json';
import idGoldTopic from './locales/id/goldTopic.json';
import idGoldTrade from './locales/id/goldTrade.json';
import idStockIndices from './locales/id/stockIndices.json';
import idCrudeOil from './locales/id/crudeOil.json';
import idStrategyTrading from './locales/id/strategyTrading.json';
import idInvite from './locales/id/invite.json';
import idPrediction from './locales/id/prediction.json';
import idDepositCouponRewards from './locales/id/depositCouponRewards.json';
import idTradingTaskRewards from './locales/id/tradingTaskRewards.json';
import idTradingTaskIntro from './locales/id/tradingTaskIntro.json';
import idReward from './locales/id/reward.json';
import idSymbols from './locales/id/symbols.json';

import msBase from './locales/ms/base.json';
import msActivity from './locales/ms/activity.json';
import msEducation from './locales/ms/education.json';
import msOpenAccount from './locales/ms/open_account.json';
import msSubscribtion from './locales/ms/subscribtion.json';
import msGoldTopic from './locales/ms/goldTopic.json';
import msGoldTrade from './locales/ms/goldTrade.json';
import msStockIndices from './locales/ms/stockIndices.json';
import msCrudeOil from './locales/ms/crudeOil.json';
import msStrategyTrading from './locales/ms/strategyTrading.json';
import msInvite from './locales/ms/invite.json';
import msPrediction from './locales/ms/prediction.json';
import msDepositCouponRewards from './locales/ms/depositCouponRewards.json';
import msTradingTaskRewards from './locales/ms/tradingTaskRewards.json';
import msTradingTaskIntro from './locales/ms/tradingTaskIntro.json';
import msReward from './locales/ms/reward.json';
import msSymbols from './locales/ms/symbols.json';

import zhTwBase from './locales/zh-tw/base.json';
import zhTwActivity from './locales/zh-tw/activity.json';
import zhTwEducation from './locales/zh-tw/education.json';
import zhTwOpenAccount from './locales/zh-tw/open_account.json';
import zhTwSubscribtion from './locales/zh-tw/subscribtion.json';
import zhTwGoldTopic from './locales/zh-tw/goldTopic.json';
import zhTwGoldTrade from './locales/zh-tw/goldTrade.json';
import zhTwStockIndices from './locales/zh-tw/stockIndices.json';
import zhTwCrudeOil from './locales/zh-tw/crudeOil.json';
import zhTwStrategyTrading from './locales/zh-tw/strategyTrading.json';
import zhTwInvite from './locales/zh-tw/invite.json';
import zhTwPrediction from './locales/zh-tw/prediction.json';
import zhTwDepositCouponRewards from './locales/zh-tw/depositCouponRewards.json';
import zhTwTradingTaskRewards from './locales/zh-tw/tradingTaskRewards.json';
import zhTwTradingTaskIntro from './locales/zh-tw/tradingTaskIntro.json';
import zhTwReward from './locales/zh-tw/reward.json';
import zhTwSymbols from './locales/zh-tw/symbols.json';

import thBase from './locales/th/base.json';
import thActivity from './locales/th/activity.json';
import thEducation from './locales/th/education.json';
import thOpenAccount from './locales/th/open_account.json';
import thSubscribtion from './locales/th/subscribtion.json';
import thGoldTopic from './locales/th/goldTopic.json';
import thGoldTrade from './locales/th/goldTrade.json';
import thStockIndices from './locales/th/stockIndices.json';
import thCrudeOil from './locales/th/crudeOil.json';
import thStrategyTrading from './locales/th/strategyTrading.json';
import thInvite from './locales/th/invite.json';
import thPrediction from './locales/th/prediction.json';
import thDepositCouponRewards from './locales/th/depositCouponRewards.json';
import thTradingTaskRewards from './locales/th/tradingTaskRewards.json';
import thTradingTaskIntro from './locales/th/tradingTaskIntro.json';
import thReward from './locales/th/reward.json';
import thSymbols from './locales/th/symbols.json';

type AppLanguageWindow = Window & {
  __applyAppFont?: (lng: string) => void;
};

const appLanguageWindow: AppLanguageWindow | null = typeof window === 'undefined' ? null : window;

// language.js 已按 URL lang 写入。主包执行时直接用，避免先以英文初始化再切换。
const bootLanguage = getRequestLanguage();

const loadFontForLanguage = (lng: string) => {
  appLanguageWindow?.__applyAppFont?.(lng);
};

// 设置文档语言属性
const setDocumentLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng);
    document.documentElement.setAttribute('data-lang', lng);
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        base: enBase,
        activity: enActivity,
        education: enEducation,
        openAccount: enOpenAccount,
        subscribtion: enSubscribtion,
        goldTopic: enGoldTopic,
        goldTrade: enGoldTrade,
        stockIndices: enStockIndices,
        crudeOil: enCrudeOil,
        strategyTrading: enStrategyTrading,
        invite: enInvite,
        prediction: enPrediction,
        depositCouponRewards: enDepositCouponRewards,
        tradingTaskRewards: enTradingTaskRewards,
        tradingTaskIntro: enTradingTaskIntro,
        reward: enReward,
        symbols: enSymbols,
      },
      'en-US': {
        base: enBase,
        activity: enActivity,
        education: enEducation,
        openAccount: enOpenAccount,
        subscribtion: enSubscribtion,
        goldTopic: enGoldTopic,
        goldTrade: enGoldTrade,
        stockIndices: enStockIndices,
        crudeOil: enCrudeOil,
        strategyTrading: enStrategyTrading,
        invite: enInvite,
        prediction: enPrediction,
        depositCouponRewards: enDepositCouponRewards,
        tradingTaskRewards: enTradingTaskRewards,
        tradingTaskIntro: enTradingTaskIntro,
        reward: enReward,
        symbols: enSymbols,
      },
      'vi-VN': {
        base: viBase,
        activity: viActivity,
        education: viEducation,
        openAccount: viOpenAccount,
        subscribtion: viSubscribtion,
        goldTopic: viGoldTopic,
        goldTrade: viGoldTrade,
        stockIndices: viStockIndices,
        crudeOil: viCrudeOil,
        strategyTrading: viStrategyTrading,
        invite: viInvite,
        prediction: viPrediction,
        depositCouponRewards: viDepositCouponRewards,
        tradingTaskRewards: viTradingTaskRewards,
        tradingTaskIntro: viTradingTaskIntro,
        reward: viReward,
        symbols: viSymbols,
      },
      'id-ID': {
        base: idBase,
        activity: idActivity,
        education: idEducation,
        openAccount: idOpenAccount,
        subscribtion: idSubscribtion,
        goldTopic: idGoldTopic,
        goldTrade: idGoldTrade,
        stockIndices: idStockIndices,
        crudeOil: idCrudeOil,
        strategyTrading: idStrategyTrading,
        invite: idInvite,
        prediction: idPrediction,
        depositCouponRewards: idDepositCouponRewards,
        tradingTaskRewards: idTradingTaskRewards,
        tradingTaskIntro: idTradingTaskIntro,
        reward: idReward,
        symbols: idSymbols,
      },
      'ms-MY': {
        base: msBase,
        activity: msActivity,
        education: msEducation,
        openAccount: msOpenAccount,
        subscribtion: msSubscribtion,
        goldTopic: msGoldTopic,
        goldTrade: msGoldTrade,
        stockIndices: msStockIndices,
        crudeOil: msCrudeOil,
        strategyTrading: msStrategyTrading,
        invite: msInvite,
        prediction: msPrediction,
        depositCouponRewards: msDepositCouponRewards,
        tradingTaskRewards: msTradingTaskRewards,
        tradingTaskIntro: msTradingTaskIntro,
        reward: msReward,
        symbols: msSymbols,
      },
      'zh-TW': {
        base: zhTwBase,
        activity: zhTwActivity,
        education: zhTwEducation,
        openAccount: zhTwOpenAccount,
        subscribtion: zhTwSubscribtion,
        goldTopic: zhTwGoldTopic,
        goldTrade: zhTwGoldTrade,
        stockIndices: zhTwStockIndices,
        crudeOil: zhTwCrudeOil,
        strategyTrading: zhTwStrategyTrading,
        invite: zhTwInvite,
        prediction: zhTwPrediction,
        depositCouponRewards: zhTwDepositCouponRewards,
        tradingTaskRewards: zhTwTradingTaskRewards,
        tradingTaskIntro: zhTwTradingTaskIntro,
        reward: zhTwReward,
        symbols: zhTwSymbols,
      },
      'th-TH': {
        base: thBase,
        activity: thActivity,
        education: thEducation,
        openAccount: thOpenAccount,
        subscribtion: thSubscribtion,
        goldTopic: thGoldTopic,
        goldTrade: thGoldTrade,
        stockIndices: thStockIndices,
        crudeOil: thCrudeOil,
        strategyTrading: thStrategyTrading,
        invite: thInvite,
        prediction: thPrediction,
        depositCouponRewards: thDepositCouponRewards,
        tradingTaskRewards: thTradingTaskRewards,
        tradingTaskIntro: thTradingTaskIntro,
        reward: thReward,
        symbols: thSymbols,
      },
    },
    lng: bootLanguage,
    fallbackLng: 'en-US',
    ns: ['base', 'activity', 'education', 'openAccount', 'subscribtion', 'goldTopic', 'goldTrade', 'stockIndices', 'crudeOil', 'strategyTrading', 'invite', 'prediction', 'depositCouponRewards', 'tradingTaskRewards', 'tradingTaskIntro', 'reward', 'symbols'],
    defaultNS: 'base',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

// 字体由 public/index.html 在主包之前按语言预加载，这里不再默认下英文
setDocumentLang(bootLanguage);

// 监听语言变化（字体在这里加载）
i18n.on('languageChanged', (lng) => {
  setDocumentLang(lng);
  loadFontForLanguage(lng);
});

export default i18n;
